import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { getUser } from '../../../apis/queries';
import Loader from '../../../components/Loader';
import Header from '../../../widgets/Header';
import DetailNotFound from '../../DetailNotFound';
import UserDetailForm from './UserDetailForm';

const EditUserButton = ({
  isEditMode,
  isEditFormSubmitting,
  ...props
}: {
  isEditMode: boolean;
  isEditFormSubmitting: boolean;
  onClick: () => void;
}) => {
  return (
    <Button disabled={isEditFormSubmitting} {...props}>
      {' '}
      {isEditMode ? 'View Mode' : 'Edit Mode'}
    </Button>
  );
};

const UserDetail = () => {
  const { id } = useParams();

  if (!id) {
    return <DetailNotFound />;
  }

  return <UserDetailContent id={id} />;
};

const UserDetailContent = ({ id }: { id: string }) => {
  const USER_QUERY_KEY = ['users', { id }];
  const { data, isLoading } = useQuery({ queryKey: USER_QUERY_KEY, queryFn: () => getUser(id) });
  const [isEditMode, setIsEditMode] = useState(false);
  const [isEditFormSubmitting, setEditFormSubmitting] = useState(false);

  const user = data?.data;

  if (isLoading) {
    return <Loader fullscreen />;
  }

  const onEditButtonClicked = () => {
    setIsEditMode(!isEditMode);
  };

  const onEditFormSubmit = (loading: boolean) => {
    setEditFormSubmitting(loading);
  };

  if (!user) {
    return <DetailNotFound />;
  }

  return (
    <div className="main-content">
      <Header
        title={user?.fullName}
        isDetailPage
        headerButton={
          <EditUserButton
            isEditFormSubmitting={isEditFormSubmitting}
            isEditMode={isEditMode}
            onClick={onEditButtonClicked}
          />
        }
      />
      <Container fluid>
        <Row className="justify-content-center">
          <Col xs={12} lg={10} xl={8}>
            <UserDetailForm
              user={user}
              isEditMode={isEditMode}
              isEditFormSubmitting={isEditFormSubmitting}
              onEditFormSubmit={onEditFormSubmit}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UserDetail;
